var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stars-wrapper"},_vm._l((100),function(star,i){return _c('div',{key:i,staticClass:"stars"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }